import _ from 'lodash'
import {
    SAVE_ALL,
    SET_DOWNLOAD_EVERYTHING,
    SET_RUN_CLIENTS_WITH_LOGGING,
    SET_RUN_CLIENTS_WITH_DX9,
    SET_SHOULD_MINIMIZE_TO_TRAY,
    SET_LANGUAGE,
    SET_TEST_SERVERS,
} from './constants'

// The names and casing of the naming here is so that it matches
// what the backend expects
const initialState = {
    LauncherEnableHardwareRendering: false,
    LauncherEnableHighDpiScaling: false,
    LauncherIgnoreCertErrors: false,
    LauncherLanguage: 'en',
    LauncherRunClientsWithDx9: false,
    LauncherRunClientsWithLogging: false,
    LauncherShouldDownloadEverything: false,
    LauncherShouldMinimizeToTray: false,
    LauncherTestServers: ['sisi', 'duality'],
    LauncherType: 0,
    LauncherUseProxy: true,
    ResManThreadCount: 0,
}

export default function settings(state = initialState, action) {
    switch (action.type) {
        // Update the launcher settings
        case SAVE_ALL: {
            // We only want to add keys that already exist in the state object
            let newState = _.pick(action.payload, _.keys(state))
            newState = { ...state, ...newState }
            // The backend uses '' for english, while we prefer to use the string 'en'
            if (newState.LauncherLanguage === '') newState.LauncherLanguage = 'en'
            return newState
        }

        case SET_DOWNLOAD_EVERYTHING: {
            return {
                ...state,
                LauncherShouldDownloadEverything: action.payload,
            }
        }

        case SET_RUN_CLIENTS_WITH_LOGGING: {
            return {
                ...state,
                LauncherRunClientsWithLogging: action.payload,
            }
        }

        case SET_RUN_CLIENTS_WITH_DX9: {
            return {
                ...state,
                LauncherRunClientsWithDx9: action.payload,
            }
        }

        case SET_SHOULD_MINIMIZE_TO_TRAY: {
            return {
                ...state,
                LauncherShouldMinimizeToTray: action.payload,
            }
        }

        case SET_LANGUAGE: {
            return {
                ...state,
                LauncherLanguage: action.payload === '' ? 'en' : action.payload,
            }
        }

        case SET_TEST_SERVERS: {
            return {
                ...state,
                LauncherTestServers: [...action.payload],
            }
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/backend/reducers.js